import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Slider from "./../Elements/Slider";
import About2 from "../Elements/About2";
import OurValue from "./../Elements/OurValue";
import About from "../Elements/About";
import ClientsLogo from "../Elements/ClientsLogo";
import { Helmet } from "react-helmet";

class Home extends React.Component {
  componentDidMount() {
    document.title =
      "Cheran Machines | Textile & Garment Printing Machine Manufacturers";
  }

  render() {
    return (
      <>
        <Helmet>
          <meta
            name="description"
            content="Cheran Machines India manufactures advanced textile and garment printing machines, offering innovative solutions for high-quality textile production."
          />
          <meta
            name="keywords"
            content="Fusing Machine, Four Head Label Transfer Press, Flash Curer Machine, Sublimation Printer, Flat Screen Printing Machine, Electric Dryer, Printing Machine, Cheran Machines India Private Limited, Coimbatore"
          />
          <link rel="canonical" href="https://www.cheranmachines.com/home" />

          {/* Open Graph */}
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://www.cheranmachines.com/home"
          />
        </Helmet>

        <Header />

        <div className="page-content">
          <Slider />
          <About2 />
          <OurValue />
          <About />
          <ClientsLogo />
        </div>

        <Footer />
      </>
    );
  }
}

export default Home;
